import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CertificateAchePage from "./pages/certificateAche";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<CertificateAchePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
